export default __webpack_public_path__ + "static/media/limit_10.9229b1a5.svg";